import React, { useState, useEffect } from 'react';
import AnimateOnScroll from './../animate';
import { Link } from 'react-router-dom';
import AdBanner from '../../ADBanner/adBanner';
import DataService from '../../../services/data.service';

const Footer = () => {
  const year = new Date().getFullYear();
  const [popularLinks, setPopularLinks] = useState([]);

  useEffect(() => {
    fetchSeoPages();
  }, []);

  const fetchSeoPages = async () => {
    try {
      const response = await DataService.getPublicSeoPages();
      if (response.data) {
        setPopularLinks(response.data.popular || []);
      }
    } catch (error) {
      console.error('Error fetching SEO pages:', error);
    }
  };

  return (
        <footer className="ftco-footer ftco-section">
    <div className="container">
      <div className="row d-flex">
        <div className="col-md">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">Divine Blush Beauty</h2>
            <p>Nestled between moments of stillness and self-care, our salon is where timeless beauty and modern artistry meet, welcoming you to relax, refresh, and renew.</p>
            <ul className="ftco-footer-social list-unstyled float-lft mt-3">
						 <AnimateOnScroll >
 <li><a href="#"><span className="icon-facebook" /></a></li>
              <li ><a href="https://www.instagram.com/divineblushbeauty?igsh=MTlzZGg2bW5kMnFsdA%3D%3D&utm_source=qr" target='blank'><span className="icon-instagram" /></a></li>
						</AnimateOnScroll>
		
            </ul>
          </div>
        </div>
        <div className="col-md">
          <div className="ftco-footer-widget mb-4 ml-md-4">
            <h2 className="ftco-heading-2">Popular Links</h2>
            <ul className="list-unstyled">
              {popularLinks.map(page => (
                <li key={page.id}>
                  <Link to={`/${page.slug}`}>{page.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="col-md">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">Quick Links</h2>
            <ul className="list-unstyled">
             <li><Link to="/about">About</Link></li>
            <li><Link to="/book-appointment">Appointment</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="col-md">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">Have a Question?</h2>
            <div className="block-23 mb-3">
              <ul>
                <li><span className="icon icon-map-marker" /><span className="text">3104, Crossbie Cres, Regina, SK, S4V3S2 </span></li>
                <li><a href="#"><span className="icon icon-phone" /><span className="text">+1 639-915-0949</span></a></li>
                <li><a href="#"><span className="icon icon-envelope" /><span className="text">contact@divineblushbeauty.com</span></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
          <p className="mb-0">
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
      <p>Copyright © {year} All rights reserved</p>
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
          </p>
        </div>
      </div>
    </div>
    <><AdBanner></AdBanner></>
  </footer>
    );
};

export default Footer;	